import { render, staticRenderFns } from "./ArchivedTerms.vue?vue&type=template&id=e7f52612&scoped=true"
import script from "./ArchivedTerms.vue?vue&type=script&lang=js"
export * from "./ArchivedTerms.vue?vue&type=script&lang=js"
import style0 from "./ArchivedTerms.vue?vue&type=style&index=0&id=e7f52612&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f52612",
  null
  
)

export default component.exports